export default __webpack_public_path__ + "static/media/bl2.07c0ac6f.png";